import { HDate } from '@shared/src/datatypes/HDate';

/***
 * Un lot de fabricació d'una línia d'albarà. Mirall exacte de
 * ShipmentDeliveryLineBatchInfoDetailObject (Java), que es desa serialitzat
 * com a JSON dins de ShipmentDeliveryLine.batchInfoJson.
 */
export class ShipmentDeliveryLineBatchInfoDetailDto {

    public batchNumber: string;
    public manufacturingDate: HDate;
    public expirationDate: HDate;
    public boxQuantity: number;
    public unitQuantity: number;
    public grossWeightInKg: number;
    public netWeightInKg: number;

    public static buildEmpty(): ShipmentDeliveryLineBatchInfoDetailDto {
        let result = new ShipmentDeliveryLineBatchInfoDetailDto();
        result.batchNumber = "";
        result.manufacturingDate = null;
        result.expirationDate = null;
        result.boxQuantity = 0;
        result.unitQuantity = 0;
        result.grossWeightInKg = 0;
        result.netWeightInKg = 0;
        return result;
    }
}

/***
 * Mirall de ShipmentDeliveryLineBatchInfoObject (Java).
 */
export class ShipmentDeliveryLineBatchInfoDto {

    public details: ShipmentDeliveryLineBatchInfoDetailDto[];

    public static buildEmpty(): ShipmentDeliveryLineBatchInfoDto {
        let result = new ShipmentDeliveryLineBatchInfoDto();
        result.details = [];
        return result;
    }

    public static getDetails(value: ShipmentDeliveryLineBatchInfoDto): ShipmentDeliveryLineBatchInfoDetailDto[] {
        return value != null && value.details != null ? value.details : [];
    }

    public static countBatches(value: ShipmentDeliveryLineBatchInfoDto): number {
        return ShipmentDeliveryLineBatchInfoDto.getDetails(value).length;
    }

    public static totalBoxQuantity(value: ShipmentDeliveryLineBatchInfoDto): number {
        return ShipmentDeliveryLineBatchInfoDto.getDetails(value)
            .reduce((sum, d) => sum + (d.boxQuantity ? +d.boxQuantity : 0), 0);
    }

    public static totalUnitQuantity(value: ShipmentDeliveryLineBatchInfoDto): number {
        return ShipmentDeliveryLineBatchInfoDto.getDetails(value)
            .reduce((sum, d) => sum + (d.unitQuantity ? +d.unitQuantity : 0), 0);
    }

    public static totalNetWeightInKg(value: ShipmentDeliveryLineBatchInfoDto): number {
        return ShipmentDeliveryLineBatchInfoDto.getDetails(value)
            .reduce((sum, d) => sum + (d.netWeightInKg ? +d.netWeightInKg : 0), 0);
    }

    public static totalGrossWeightInKg(value: ShipmentDeliveryLineBatchInfoDto): number {
        return ShipmentDeliveryLineBatchInfoDto.getDetails(value)
            .reduce((sum, d) => sum + (d.grossWeightInKg ? +d.grossWeightInKg : 0), 0);
    }
}
